<script>
export default {
    props: {
        text: {
            type: String,
            default: 'Cancel'
        },
        variant: {
            type: String,
            default: 'outlined'
        }
    }
};
</script>

<template>
    <v-btn :text="text" :variant="variant" @click="$emit('cancel')"/>
</template>

